import { Circle, Flex, Text } from 'components'
import { useTheme } from 'utils'

interface Props {
  label: string
  count: number
}

export default function EventsSectionHeader({ label, count }: Props) {
  const { theme } = useTheme()

  return (
    <Flex direction="row" align="center" gap={2}>
      <Circle size="30px" borderWidth="2px" borderColor={theme === 'light' ? 'black' : 'white'}>
        <Text textStyle="bodyMedium">{count}</Text>
      </Circle>
      <Text textStyle="bodyLarge">{label}</Text>
    </Flex>
  )
}
